import React, { useState } from 'react';
import logo_close from '../assets/close-check.png';
import '../styles/Reserve.css';
import { isDemoKey } from "../services/kdoServices";

function Reserve({p_object,p_key,p_isProprio,p_withButton = true, p_onReserved}) {

    const [isformReserve, setisformReserve] = useState(false)
    const [emailValue, setEmailValue] = useState('')
    const [nomValue, setNomValue] = useState('')
    const [isDataRegistering, setIsDataRegistering] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)
    const [isError, setError] = useState(false)
    const [tmpKey, setTmpKey] = useState('')
    
    if(tmpKey === '')
        {
            const timestamp = Date.now();
            setTmpKey(timestamp);
            console.log("timestamp " + tmpKey);
        }

    function handleInputMail(e) {
		setEmailValue(e.target.value)
	}
    function handleInputNom(e) {
		setNomValue(e.target.value)
	}

    async function requestReservation()
    {
        if(isValidEmail(emailValue))
        {
            if(isDemoKey(p_key))
            {
                alert("Mode démonstration, la reservation n'est faite que dans cette session de démo, elle disparaitra si vous rechargez de la page.")
                const reservationId = -1;
                p_object.reservationid = reservationId
                if (typeof p_onReserved === "function") {
                    p_onReserved(reservationId);
                }
                setIsCompleted(true);
            }
            else
            {
                registerReservation(nomValue,emailValue,p_object.id)
            }
        }
        else
        {
            alert("Attention, ceci n'est pas une adresse valide 😥")
        }
    }

    async function registerReservation(p_nom, p_email,p_idObject) {

        console.log("registerReservation debut");
        const requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: p_email,
                name : p_nom,
                idObject : p_idObject
            }),
        };

        try {
            let v_responseJson = {};
                console.log("tmpKey " + tmpKey);
                setIsDataRegistering(true)
                const response = await fetch("https://app.listaki.fr/api/WS/reservation.php?key="+tmpKey, requestOptions)
                if (response.ok) {
                    v_responseJson = await response.json();
                    console.log("Reponse api debut");
                    console.log(v_responseJson)
                    console.log("Reponse api fin");
                    if(v_responseJson["success"]) {
                        const reservationId = v_responseJson["reservationId"];
                        p_object.reservationid = reservationId;
                        if (typeof p_onReserved === "function") {
                            p_onReserved(reservationId);
                        }
                    }
                    else alert(v_responseJson["error"])
                    setIsCompleted(true);
                } else {
                    console.log("Erreur lors de l'appel à l'API");
                    v_responseJson = await response.json();
                    if(v_responseJson["error"]) alert(v_responseJson["error"])
                    setError(true);
                }
        } catch (err) {
            console.log(err)
        } finally {
            setIsDataRegistering(false)
        }
    };
    
    function isValidEmail(p_email) {
        console.log(p_email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(p_email);
    }

    const v_title = p_object.objectname && p_object.objectname.length > 50 
        ? p_object.objectname.substring(0, 50) + "..." 
        : p_object.objectname || '';
    const v_link = p_object.tinyCode != null
        ? 'https://fliz.ly/' + p_object.tinyCode + '_w'
        :p_object.urllink;
    const v_isReserved = p_object.reservationid != null; // on utilise != et pas !== car reservationid peut être undifined ou null, !== ne prend que null

    return !v_isReserved & isformReserve ? (
        <div className="ui-overlay">
            <div className="ui-modal">
            <img src={logo_close} alt="Fermer" onClick={() => setisformReserve(false)} className='kdo-logoclose'/>
                <div>
                    <p>Vous souhaitez reserver l'article suivant pour l'acheter ?</p>
                    <p>{p_object.imagelink ? (
                    <img 
                        className='kdo-object-image'
                        src={p_object.imagelink} 
                        alt={p_object.objectname} 
                    />
                ) : (null)}</p>
                    <p><div className='kdo-object-title'>{v_link !== ""? (<a href={v_link} target="_blank" rel = "noopener noreferrer">{v_title}</a>):(<div>{v_title}</div>)}</div></p>
                    <p>Afin que personne d'autre ne l'achete, marquez le comme réservé. Vous pourrez toujours ensuite cliquer sur le liens pour aller l'acheter.</p>
                    <input
                        placeholder='Entrez votre nom'
                        onChange={handleInputNom}
                    />
                    <input
                        placeholder='Entrez votre mail'
                        onChange={handleInputMail}
                    />     
                    
                    <div className="ui-buttons"> 
                        <button className="ui-buttons" onClick={() => { 
                                        if (window.umami) window.umami.track('reserve-object');
                                        requestReservation();
                                    }}>Je reserve l'article</button>
                    </div>
                    <p>Une fois reservé, l'article sera visible comme déjà reservé par les autres utilisateurs.</p>
                </div>
            </div>
        </div>
    ) : v_isReserved & isformReserve ? 
    (
        <div className="ui-overlay">
            <div className="ui-modal">
            <img src={logo_close} alt="Fermer" onClick={() => setisformReserve(false)} className='kdo-logoclose'/>
                <div>
                    <p>Vous venez de reserver l'article suivant, vous pouvez maintenant l'acheter en utilisant le lien ci dessous.</p>
                    <p>{p_object.imagelink ? (
                    <img 
                        className='kdo-object-image'
                        src={p_object.imagelink} 
                        alt={p_object.objectname} 
                    />
                ) : (null)}</p>
                    <p><div className='kdo-object-title'>{v_link !== ""? (<a href={v_link} target="_blank" rel = "noopener noreferrer">{v_title}</a>):(<div>{v_title}</div>)}</div></p>
                </div>
            </div>
        </div>
    ) : v_isReserved ?
    (
        <div className='kdo-reserved-ribbon' title='Objet reserve' aria-label='Objet reserve'>
            Reservé
        </div>
    ) : (
        !p_isProprio && p_withButton ? (
            <button onClick={() => setisformReserve(true)}>Reserver</button>
        ) : null
    )

};

export default Reserve;
